<template>
    <b-modal id="vehicle-stock-message" :title="title" @ok="sendMessage" ref="messageModal">
        <div class="form-group inline-label">
            <label for="vehicle-stock-message-textarea">Message</label>
            <textarea ref="message" id="vehicle-stock-message-textarea" v-model="message"></textarea>
        </div>
        <b-form-checkbox v-if="showWithEmail" v-model="withEmail" id="email_to_user" class="float-left"></b-form-checkbox>
        <b-form-group v-if="showWithEmail" :label="emailCheckBoxLabel" label-for="email_to_user"></b-form-group>
    </b-modal>

</template>
<script>
    import {handleHttpError} from '../../util/common'
    export default {
        created(){
        },
        mounted(){
        },
        data() {
            return {
                message: null,
                user: {name: ''},
                vehicleStock: {},
                repOnly: false,
                withEmail: false
            }
        },
        computed: {
            title(){
                let msg = 'Message';
                if (this.user && this.user.name) {
                    msg += ' - '+ this.user.name;
                }
                return msg;
            },
            showWithEmail(){

                if (this.vehicleStock.user_id === this.loggedInUser.id) {
                    if (this.loggedInUser && !this.loggedInUser.sales_rep) {
                        return false;
                    }
                }
                return true;
            },
            emailCheckBoxLabel(){
                let label = '';
                if (this.vehicleStock.user_id === this.loggedInUser.id) {
                    if (this.loggedInUser && this.loggedInUser.sales_rep && this.loggedInUser.sales_rep.name) {
                        label = 'Also e-mail this message to my sales rep - ' + this.loggedInUser.sales_rep.name;
                    } else {
                        label = 'Also e-mail this message to my sales rep';
                    }
                } else {
                    if (this.vehicleStock && this.vehicleStock.user && this.vehicleStock.user.name) {
                        label = 'Also e-mail this message to ' + this.vehicleStock.user.name;
                    } else {
                        label = 'Also e-mail this message to owner';
                    }
                }
                return label;
            },
        },
        methods: {
            openModal(vehicleStock, repOnly, msg = ''){
                this.$refs.messageModal.show();
                this.message = msg;
                this.vehicleStock = vehicleStock;
                this.user = vehicleStock.user_id;
                this.repOnly = repOnly;
                console.log('vehicleStock', {vehicleStock: vehicleStock})
                setTimeout(()=>{
                    this.$refs.message.focus();
                }, 200);
            },
            async sendMessage(){
                let args;
                try {
                    let vehicleStockId = this.vehicleStock.id;
                    let message = this.message;
                    args = {vehicle_stock_id: vehicleStockId, rep_only: this.repOnly, message: message,
                        with_email: this.withEmail}
                    let result = await this.$store.dispatch('vehicleStock/addMessage', args);
                    if (result && result.message) {
                        this.$emit('changed', vehicleStockId, result.message);
                    }
                } catch (e) {
                    console.warn('sentMessage error', e, args)
                    handleHttpError(e);
                }
            },
        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/VehicleStock/VehicleStockMessage.vue